import { colors, styleScreenDashboard } from "../../styles/style";
import Card from "react-bootstrap/Card";
import { styleScreen } from "./style";

/**
 * @param {String} statusDelivery Cercanía del delivery (A - Cerca / B - No muy lejos / C - Lejos)
 * @param {String} kmDistance Distancia en km del delivery
 * @returns Circulo de color y texto dependiendo de la cercanía del delivery
 */
const colorStatus = ({ statusDelivery, kmDistance }) => {
  const textStatus = (status, type) => {
    if (type === "text") {
      switch (status) {
        case "A":
          return "Cerca";
        case "B":
          return "No muy lejos";
        case "C":
          return "Lejos";
        case "D":
          return "Desconocido";
        default:
          return "---";
      }
    } else {
      switch (status) {
        case "A":
          return colors.GREEN_COLOR;
        case "B":
          return colors.YELLOW_COLOR;
        case "C":
          return colors.RED_COLOR;
        case "D":
          return colors.GRAY_3_COLOR;
        default:
          return colors.GRAY_3_COLOR;
      }
    }
  };

  return (
    <div className={"row"} style={styleScreen.rowContainer}>
      <div className={"col-1"}>
        <div
          style={{
            height: 15,
            width: 15,
            borderRadius: 50,
            backgroundColor: textStatus(statusDelivery, "color"),
          }}
        />
      </div>
      <div className={"col"} style={styleScreenDashboard.textCardDelivery}>
        <Card.Subtitle className="mb-2 text-muted">
          {textStatus(statusDelivery, "text")}
        </Card.Subtitle>
        <Card.Subtitle className="mb-2 text-muted">
          {!!kmDistance ? ` (${kmDistance} km)` : "--.--"}
        </Card.Subtitle>
      </div>
    </div>
  );
};

export default colorStatus;
